import { Dispatch } from "redux";
import actions from "@state/actions";

export const fetchIndustries = (dispatch: Dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(actions.industries.getIndustries((result, error) => {
      if (error) reject(error)
      else resolve(result)
    }))
  });
}
